import { Api } from '../lib'

const TYPE = {
  receive_payment_token : 'RECEIVE_PAYMENT_TOKEN',
  receive_payment_nonce : 'RECEIVE_PAYMENT_NONCE',
  removed_credit_card   : 'REMOVE_CREDIT_CARD',
  added_credit_card     : 'ADD_CREDIT_CARD',
  cleared               : 'CLEARED',
  payment_error         : 'PAYMENT_ERROR'
}

const node_api = new Api({node_api: true})


const getToken = () => dispatch => node_api

  .get('payment_token')

  .then(response => dispatch({
    type: TYPE.receive_payment_token,
    payload: response.data
  }))

  .catch(err => dispatch({type: TYPE.payment_error, payload: err}))


const getNonce = payment_instance => dispatch =>
  payment_instance.requestPaymentMethod((err, payload) => {
    if (err)
      dispatch({type: TYPE.payment_error, payload: err})

    dispatch({payload, type: TYPE.receive_payment_nonce})
  })


const addPaymentMethod = form => dispatch =>
  node_api.post('payment_method', {body: form})

    .then(result => dispatch({
      type: TYPE.added_credit_card,
      payload: result.data.creditCard
    }))


const reset = () => dispatch => dispatch({type: TYPE.cleared})


const removeCreditCard = token => dispatch =>
  node_api.delete('payment_method_by_token', {keys: {token}})

    .then(() => dispatch({type: TYPE.removed_credit_card, payload: token}))


export default {
  TYPE,
  reset,
  getNonce,
  getToken,
  addPaymentMethod,
  removeCreditCard
}
